$(document).ready(function($) {
    $('.accordion-columns .wp-block-column:first-child').on('click', function() {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            $(this).parents('.accordion').find('.accordion-columns').removeClass('active');
            $(this).parent().addClass('active');
        }
    });
});